import { render, staticRenderFns } from "./NsbKycLogo.vue?vue&type=template&id=140780ce&scoped=true&"
import script from "./NsbKycLogo.vue?vue&type=script&lang=js&"
export * from "./NsbKycLogo.vue?vue&type=script&lang=js&"
import style0 from "./NsbKycLogo.vue?vue&type=style&index=0&id=140780ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140780ce",
  null
  
)

export default component.exports